exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".line[data-v-2dbe74c5]{width:91%;border-bottom:1px dashed #999}.line[data-v-2dbe74c5],.second_line[data-v-2dbe74c5]{margin-left:3%;display:inline-block;height:1px;vertical-align:middle}.second_line[data-v-2dbe74c5]{width:87%;border-bottom:1px dashed #666}.word_num[data-v-2dbe74c5]{display:inline-block;vertical-align:bottom;margin-bottom:22px;margin-left:5px;color:#666}.pic_tip[data-v-2dbe74c5]{font-size:12px;color:#ff4949;line-height:1px;padding-top:4px;position:absolute;top:100%;left:0}.pic_skan[data-v-2dbe74c5]{width:150px;height:150px}.pic_min_skan[data-v-2dbe74c5],.pic_skan[data-v-2dbe74c5]{margin-top:5px;border:1px solid #c0ccda;border-radius:6px;box-sizing:border-box;cursor:pointer}.pic_min_skan[data-v-2dbe74c5]{width:60px;height:60px}.form_color[data-v-2dbe74c5]{color:#6a484d}.el-form-item[data-v-2dbe74c5]{margin-bottom:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-2dbe74c5","scoped":true,"hasInlineConfig":false}!./~/less-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/modules/supplier/basicInfo.vue
// module id = 362
// module chunks = 0